// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ZI1Fg","controller":"styles_controller__Vg3bY","list":"styles_list__T0vVN"};